import { render } from "./SectionComponent.vue?vue&type=template&id=7f8c194c"
const script = {}

import "./SectionComponent.vue?vue&type=style&index=0&id=7f8c194c&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__